// extracted by mini-css-extract-plugin
export default {"modalContainer":"ChatModal_modalContainer__cqh79","title":"ChatModal_title__g2kSd","modalBody":"ChatModal_modalBody__24mDX"};